import "reflect-metadata";
import {inject, injectable} from "inversify";
import {SectorRepository} from "@dropDesk/domain/repositories/sector/sector.repository";
import {SectorEntity} from "@dropDesk/domain/entities/sector/sector.entity";

@injectable()
export class FindByPKSectorUseCase {
  private _repository: SectorRepository;

  constructor(@inject(SectorRepository) repository: SectorRepository) {
    this._repository = repository;
  }

  public call(id: string): Promise<SectorEntity> {
    return this._repository.findByPK(id);
  }
}

